/**
 * Saldo atual do ativo, na cascata que o payload da carteira exige: o backend
 * manda o valor já formatado em `Aplicação_f` (ou `aplicacao_f`) e só o número
 * cru em `pl_atual`, dependendo de por onde a linha veio.
 *
 * Existe como util porque o KPI e o campo da ficha mostram a MESMA grandeza:
 * com a cascata copiada nos dois, um ajuste de fonte acerta um lado e deixa o
 * outro divergente, exibindo saldos diferentes na mesma tela.
 */

import { getNumber, toMoney } from '@utils/Format'

export const resolveAssetSaldo = ({ asset } = {}) => {
  if (!asset) {
    return ''
  }
  return (
    asset['Aplicação_f'] ||
    asset.aplicacao_f ||
    toMoney(getNumber(asset.pl_atual)) ||
    ''
  )
}
